<div class="container-fluid">
    <div class="row">
        <app-section-title title="TITLES.COMPARATIVE-GRAPHS">
        </app-section-title>
    </div>

    <p>comparative-graphs works!</p>
</div>